<template lang="pug">
.side-menu
  .menu
    .menu-header TOP RATED
    .menu-link.location(@click="goTo({ name: 'info', params: { id: topRated[0].doc.osm_id } })")
      span
        | #1 {{ topRated[0].doc.name }}
    .menu-link.about(@click="goTo({ name: 'about' })")
      span About
    .menu-link.help(@click="goTo({ name: 'help' })")
      span Help
    .menu-link.search(@click="goTo({ name: 'map' })")
      span Search
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SideMenu',
  props: ['switchMenu'],
  components: {
  },
  data () {
    return {
      no1: null
    }
  },
  computed: mapState([
    'topRated'
  ]),
  methods: {
    goTo (params) {
      this.$root.$emit('switchMenu')
      this.$router.push(params)
    }
  }
}
</script>

<style lang="stylus" scoped>
.side-menu
  background url('~/img/menu-background-bottom.png') bottom no-repeat, url('~/img/menu-background-top-long.jpg') bottom no-repeat
  background-size 100%
  padding-top calc(170%)
  @media(max-height 570px)
    background url('~/img/menu-background-bottom-cut.png') bottom no-repeat, url('~/img/menu-background-top.jpg') center no-repeat
    background-size 100%
    padding-top calc(148% + 50px)
  @media(max-height 490px)
    background url('~/img/menu-background-bottom-cut.png') center 110% no-repeat, url('~/img/menu-background-top.jpg') center no-repeat
    background-size 100%
    padding-top calc(148% + 50px)
  @media(min-height 571px) and (max-width 900px)
    background url('~/img/menu-background-bottom.png') bottom no-repeat, url('~/img/menu-background-top.jpg') center no-repeat
    background-size 100%
    padding-top calc(148% + 50px)
  display block
  width 100%
  position relative
.menu
  display flex
  position absolute
  top 0
  left 0
  font-family 'JEMBOhands'
  flex-direction column
  width 100%
  height 100%
  justify-content space-between
  padding-bottom 140px
  overflow hidden
  @media(min-width 900px)
    @media(max-height 720px)
      padding-top 40px
    @media(max-height 680px)
      padding-top 80px
    @media(max-height 635px)
      padding-top 120px
    @media(max-height 595px)
      padding-top 160px
    @media(max-height 515px)
      padding-top 190px
    @media(max-height 490px)
      padding-top 220px
    @media(max-height 460px)
      padding-top 260px
    @media(max-height 414px)
      padding-top 280px
  @media(min-width 415px) and (max-width 899px)
    @media(max-height 700px)
      padding-top 40px
    @media(max-height 630px)
      padding-top 80px
    @media(max-height 590px)
      padding-top 100px
    @media(max-height 570px)
      padding-top 140px
    @media(max-height 540px)
      padding-top 165px
    @media(max-height 515px)
      padding-top 180px
    @media(max-height 495px)
      padding-top 205px
    @media(max-height 470px)
      padding-top 230px
    @media(max-height 440px)
      padding-top 260px
    @media(max-height 440px)
      padding-top 280px
    @media(max-height 375px)
      padding-top 240px
    @media(max-height 360px)
      padding-top 260px
    @media(max-height 340px)
      padding-top 280px
  @media(max-width 414px)
    @media(max-height 700px)
      padding-top 20px
    @media(max-height 620px)
      padding-top 60px
    @media(max-height 590px)
      padding-top 100px
    @media(max-height 540px)
      padding-top 140px
    @media(max-height 500px)
      padding-top 180px
    @media(max-height 460px)
      padding-top 210px
    @media(max-height 440px)
      padding-top 230px
    @media(max-height 420px)
      padding-top 260px
    @media(max-height 390px)
      padding-top 280px
    @media(max-height 375px)
      padding-top 240px
    @media(max-height 360px)
      padding-top 260px
    @media(max-height 340px)
      padding-top 280px
  @media(max-width 376px)
    @media(max-height 700px)
      padding-top 20px
    @media(max-height 620px)
      padding-top 30px
    @media(max-height 590px)
      padding-top 70px
    @media(max-height 540px)
      padding-top 110px
    @media(max-height 500px)
      padding-top 150px
    @media(max-height 460px)
      padding-top 180px
    @media(max-height 440px)
      padding-top 200px
    @media(max-height 420px)
      padding-top 230px
    @media(max-height 390px)
      padding-top 250px
    @media(max-height 375px)
      padding-top 230px
    @media(max-height 360px)
      padding-top 260px
    @media(max-height 340px)
      padding-top 280px
  @media(max-width 360px)
    @media(max-height 590px)
      padding-top 30px
    @media(max-height 540px)
      padding-top 70px
    @media(max-height 500px)
      padding-top 110px
    @media(max-height 460px)
      padding-top 140px
    @media(max-height 440px)
      padding-top 160px
    @media(max-height 420px)
      padding-top 180px
    @media(max-height 390px)
      padding-top 200px
    @media(max-height 360px)
      padding-top 225px
    @media(max-height 340px)
      padding-top 245px
  @media(max-width 330px)
    @media(max-height 590px)
      padding-top 0px
    @media(max-height 540px)
      padding-top 20px
    @media(max-height 500px)
      padding-top 60px
    @media(max-height 460px)
      padding-top 80px
    @media(max-height 440px)
      padding-top 110px
    @media(max-height 420px)
      padding-top 140px
    @media(max-height 390px)
      padding-top 160px
    @media(max-height 360px)
      padding-top 180px
    @media(max-height 340px)
      padding-top 200px
  @media(max-width 400px)
    padding-bottom 32%
  @media(max-height 570px)
    padding-bottom 22%
  @media(max-height 490px)
    padding-bottom 12%

.menu-link
  display flex
  justify-content center
  flex-grow 1
  flex-shrink 0
  flex-basis auto
  height 20%
  width 160px
  @media(max-width 400px)
    width 120px
  align-items center
  justify-content center
  text-align center
  cursor pointer
  color rgb(0, 0, 0)
  &:hover
    span
      text-decoration underline
  span
    text-transform uppercase
    font-size 13px
    @media(min-height 571px) and (max-height 740px)
      font-size 12px
    @media(max-height 570px)
      font-size 11px
    @media(max-height 470px)
      font-size 10px
    @media(max-height 400px)
      font-size 9px
    font-weight bold
    display inline-block
    vertical-align middle
.location
  margin-left 25px
  background url('~/img/menu-location-link.png') center no-repeat
  background-size contain
  span
    transform rotate(-10deg)
.about
  align-self flex-end
  margin-top -25px
  margin-right 60px
  background url('~/img/menu-about-link.png') center no-repeat
  background-size contain
  span
    transform rotate(5deg)
.help
  margin-top -35px
  margin-left 30px
  background url('~/img/menu-help-link.png') center no-repeat
  background-size contain
  span
    transform rotate(-5deg)
.search
  align-self flex-end
  margin-top -20px
  margin-right 40px
  background url('~/img/menu-search-link.png') center no-repeat
  background-size contain
  span
    transform rotate(1deg)
.menu-header
  margin-top 50px
  text-align center
  color #2d0f00
  transform rotate(-5deg)
  font-family 'PEIXE', arial, sans-serif
  font-size 50px
  @media(max-height 570px)
    font-size 45px
  @media(max-height 470px)
    font-size 35px
  @media(max-height 400px)
    font-size 30px
  font-weight bold
</style>
